import { Suspense } from 'react';
import Container from '../../components/Container';
import { ListSearch } from './components/list';
import { useRoot } from './hooks/useRoot';

export const Search = () => {
  const { searchData, loadingMore, onFetchMore, canLoadMore } = useRoot();

  return (
    <Container className="mt-8">
      <div className="col-span-12">
        <h1 className="font-cadiz text-sh-28-32 font-bold">Search results</h1>
        <ListSearch
          data={searchData || []}
          loadMoreData={() => {
            onFetchMore();
          }}
          loadingMore={loadingMore}
          canLoadMore={canLoadMore}
        />
      </div>
    </Container>
  );
};
export const SearchScreen = () => {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
        </div>
      }>
      <Search />
    </Suspense>
  );
};
